import type { IProductListApiParams } from '@/api/types/product';

export type ProductListRequestOptions = Pick<
  IProductListApiParams,
  'in_stock' | 'stock_sort_first'
>;

export const COLLABORATION_PRODUCT_LIST_REQUEST_OPTIONS = {
  in_stock: 3,
  stock_sort_first: 1,
} as const satisfies ProductListRequestOptions;
